import { apiClient } from './apiClient';

export const SALESET_REGISTER_TYPE_API_ENDPOINT = 'saleset-register-type';

export const saleSetRegisterTypeApi = {
    selectAll: () => apiClient.get(`${SALESET_REGISTER_TYPE_API_ENDPOINT}`),
    selectByHocSinh: (ts_hocsinh_id:number) => apiClient.get(`${SALESET_REGISTER_TYPE_API_ENDPOINT}/select-by-hs/${ts_hocsinh_id}`),
};
